export default {
  namespaced: true,
  state: {
    schemas: []
  },
  getters: {
    getSchemas (state) {
      return state.schemas
    },
    getSchemaById: (state) => (schemaId) => {
      return state.schemas.find(schema => Number(schema.id) === Number(schemaId))
    }
  },
  actions: {
    async initSchemas ({ commit }, schemas) {
      commit('setSchemas', schemas)
    }
  },
  mutations: {
    setSchemas (state, schemas) {
      state.schemas = schemas
    }
  }
}
